import { useApolloClient, useMutation } from '@apollo/client/react';
import { Alert, Button, Flex, Modal, Typography } from 'antd';

import SectionMessage from 'components/SectionMessage/SectionMessage';
import { UNENROLL_PRECHARGEOFF_SETTLEMENT_OFFER } from 'mutations/prechargeoff';
import { SIZE, STATUS } from 'utilities/constants';

const { Text } = Typography;

const PrecoCancelOfferModal = ({ offerId, hide, ...modalProps }) => {
  const client = useApolloClient();

  const [unenrollOffer, { loading, error, data: cancelSuccess, reset }] =
    useMutation(UNENROLL_PRECHARGEOFF_SETTLEMENT_OFFER, {
      onError: () => {},
      onCompleted: () =>
        setTimeout(() => {
          client.refetchQueries({
            include: [
              'GetCurrentPrecoOffer',
              'GetPrecoEligibility',
              'AccountHistory',
            ],
          });
          handleCancel();
        }, 2500),
    });

  const handleConfirm = () => {
    unenrollOffer({ variables: { offerId } });
  };

  const handleCancel = () => {
    reset();
    hide();
  };

  return (
    <Modal
      {...modalProps}
      title="Cancel Pre-Chargeoff Offer"
      width={500}
      footer={null}
      onCancel={handleCancel}
      destroyOnHidden={true}
    >
      <Flex
        vertical
        gap="var(--spacing-sm)"
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        <Text>
          Are you sure you want to cancel this offer? This action cannot be
          undone.
        </Text>
        <Flex justify="flex-end" gap="var(--spacing-sm)">
          <Button onClick={handleCancel}>No, keep offer</Button>
          <Button
            danger
            type="primary"
            onClick={handleConfirm}
            loading={loading}
          >
            Yes, cancel offer
          </Button>
        </Flex>
        {error && (
          <Alert
            banner
            type="error"
            title="Failed to cancel offer. Please try again."
          />
        )}
        <SectionMessage
          cover={true}
          status={STATUS.SUCCESS}
          size={SIZE.SM}
          text="Offer successfully canceled"
          visible={!!cancelSuccess}
        />
      </Flex>
    </Modal>
  );
};

export default PrecoCancelOfferModal;
